import { FlightSummary } from "@models/index";
import { Passenger } from "@models/passenger.model";
import {
  BookedLegInt,
  BookedTravelerCollectionInt,
  CorporateRecognitionInt,
} from "@interfaces/*";
import { Segment } from "@models/cart/segment.model";
import { CHECKIN_STATUS } from "@app/enums";

export class Reservation {
   apiCart: any;
   checkinStatus: CHECKIN_STATUS;
   autoCheckin: string;
   corporateRecognition?: CorporateRecognitionInt;
   flightItineraryType: any;
   flightSummary: FlightSummary;
   isStandByBooking: any;
   kioskStartTime: any;
   passengers: Passenger[];
   paxOnStandByList: any;
   pnr: string;
   pnrCode: any;
   segments: Segment[];
   showAttestation: boolean;
   standByListPaxLimit: any;
   toHavana: boolean;
   tsaRequired:  boolean = false;
   showNoticeGuatemala: boolean;
   showGender: boolean = false;
   legRegion: string;

  constructor(data?:{pnrCode: string, cart?: BookedTravelerCollectionInt, leg: BookedLegInt, kioskLocation: string}) {
    if(data){
      const {pnrCode,cart,leg,kioskLocation} = data;
      this.flightSummary = new FlightSummary(cart, leg, kioskLocation);
      this.kioskStartTime = new Date();
      this.paxOnStandByList = leg.paxOnStandByList;
      this.pnr = pnrCode;
      this.showAttestation = cart?.showAttestation;
      this.standByListPaxLimit = leg.standByListPaxLimit;
      this.toHavana = cart?.toHavana;
      this.showNoticeGuatemala = cart?.showNoticeGuatemala;
      this.checkinStatus = leg.checkinStatus;
    }
  }
}
